module.exports = __webpack_public_path__ + "img/tap-area.e15a55f0.svg";